const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoPf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 59",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1151.08,-574.102)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,-1,1,6.12323e-17,0,1080)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "po-pf",
    transform: "matrix(1,0,0,1,0,66.1337)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,1080,-6.61309e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112.65,628.548L1095.79,628.548L1111.21,603.816L1111.48,603.386L1111.21,602.957L1095.79,578.225L1112.65,578.225L1112.65,628.548Z",
    style: {
      fill: "rgb(145,70,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,1080,-6.61309e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112.65,628.548L1095.79,628.548L1111.21,603.816L1111.48,603.386L1111.21,602.957L1095.79,578.225L1112.65,578.225",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(145,70,255)",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,1080,-6.61309e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1089.07,578.225L1089.52,578.225L1105.21,603.386L1089.52,628.548L1089.07,628.548",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(145,70,255)",
      strokeWidth: 2
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoPf);
export default __webpack_public_path__ + "static/media/po-pf.a32335732e9b196eb45a4a415dbfa011.svg";
export { ForwardRef as ReactComponent };